export enum AnalysisType {
    FULL_ANALYSIS = 0,
    IMPACT_ANALYSIS = 1,
    COMPONENT_ANALYSIS = 2
}
